module.exports = __webpack_public_path__ + "img/puzzle9_8.a436e3d9.jpg";